import { redirectUnauthedUser } from './redirectUnauthedUser';
import { scheduleExpiredSessionRedirect } from './scheduleExpiredSessionRedirect';
import { getAccessToken } from 'src/common/external/aws/getAccessToken';
import { signOut } from 'src/common/external/aws/signOut';

// Both API clients (the legacy bambiBaseQuery and @bambi/api-client) resolve
// their bearer token through here — the one choke point that sees every
// request attempted on a dead session.
const getAccessTokenHandlingExpiry = async (): Promise<string | undefined> => {
  const token = await getAccessToken();
  if (!token) {
    scheduleExpiredSessionRedirect();
  }
  return token;
};

// Single seam for auth actions:
// - signOut: explicit "Sign out" — clears tokens + the Hosted-UI session cookie
//   (via /logout) and lands on the marketing site.
// - redirectUnauthedUser: missing/expired session — bounce to the Hosted UI to
//   (re-)authenticate.
const authService = {
  signOut,
  getAccessToken: getAccessTokenHandlingExpiry,
  redirectUnauthedUser,
};

export { authService };
